import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import useFetchData from '../../../hooks/useFetchData';
import Api from '../../../utils/api';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import EmailSms from 'components/EmailSms';
import translating from '../translate.json';
import Button from '../../Button';
import GlobalContext from 'contexts';

const SendSMS = ({ mobile, email, handleChangeMode }) => {
  const { data: systemMsgs } = useFetchData('notifications');
  const [selectedMsg, setSelectedMsg] = useState();
  const [messages, setMessages] = useState();
  const [showMessage, setShowMessage] = useState();
  const [currentType, setType] = useState();
  const { currentCustomer } = useContext(GlobalContext);

  useEffect(() => {
    if (systemMsgs?.length) {
      let messages = [...systemMsgs];
      messages = messages.filter(
        (n) =>
          n.description &&
          n.description !== '' &&
          !n.IsScheduler &&
          !n.description.includes('$')
      );
      messages.push({ name: 'custom', description: '' });
      setMessages(messages);
    }
  }, [systemMsgs]);

  const setCustomMsg = (index, e) => {
    let copyMsgs = [...messages];
    copyMsgs[index].description = e.target.value;
    setMessages(copyMsgs);
  };

  const handleChooseMsg = (index) => {
    let copyMsgs = [...messages];
    copyMsgs.forEach((msg) => {
      msg.select = false;
    });
    copyMsgs[index].select = true;
    setSelectedMsg(copyMsgs[index]);
    setMessages(copyMsgs);
  };

  const handleSendMsg = () => {
    Api.post('sms-email/SendEmailSms', {
      recipeint: mobile,
      email: email,
      Subject: selectedMsg.name,
      body: selectedMsg.description,
      messageStatus: 'Success',
      messageType: currentType?.length > 1 ? 'eMailSms' : currentType[0],
      clientId: currentCustomer.id
    }).then((res) => {
      if (res?.status == 201) {
        setTimeout(() => {
          setShowMessage(false);
          handleChangeMode(null);
        }, 4000);
        setShowMessage(true);
      }
    });
  };

  return (
    <div className="send-sms">
      <div className="send-sms-target">
        <div className="send-sms-target-title">{translating.sendTarget} </div>
        <EmailSms
          mobile={mobile}
          email={email}
          handleSetType={(type) => setType(type)}
        ></EmailSms>
      </div>
      <div className="send-sms-messages">
        <div className="send-sms-target-title">{translating.sendMsgTitle} </div>
        <div className="send-sms-messages-list">
          {messages?.map((msg, index) => (
            <div className="wraper-sms-msg" key={index}>
              <Checkbox
                disableTouchRipple
                checked={msg.select === true}
                onChange={() => handleChooseMsg(index)}
              />
              {msg.name === 'custom' ? (
                <TextareaAutosize
                  placeholder="כתוב את ההודעה שלך"
                  maxLength={500}
                  onFocus={() => handleChooseMsg(index)}
                  onChange={(e) => setCustomMsg(index, e)}
                />
              ) : (
                <div className="sms-msg">{msg.description}</div>
              )}
            </div>
          ))}
        </div>
        <div className="wrapper-send-btn">
          <Button
            disable={!selectedMsg?.description || showMessage}
            txt={translating.send}
            handleClick={handleSendMsg}
          ></Button>
        </div>
      </div>
      {showMessage && (
        <div className="succsses-msg">{translating.succsses}</div>
      )}
    </div>
  );
};

export default SendSMS;

SendSMS.propTypes = {
  email: PropTypes.string,
  mobile: PropTypes.string,
  handleChangeMode: PropTypes.func
};
